.label {
  color: var(--mantine-color-gray-6);
  font-weight: 500;

  &[data-active] {
    color: var(--mantine-color-gray-10);
    font-weight: 700;
  }
}
